import { ExtraHelpers, PermissionHelper } from "../../more/Helpers";

var syncfusionLkSet = false;
var syncfusionLocSet = false;

/**
 * Funktion um die Syncfusion Lizense zu registrieren.
 * @param license_key Lizens Schluessen von Syncfusion (string)
 * @returns Ob die License geladen werden konnte oder nicht (boolean)
 * ```TypeScript
 * if (loadLicense(this.getModule("Webcalendar")["license"]) == false)
 * {
 *  console.error("license error...");
 * }
 * ```
 */
function loadLicense(license_key:string):boolean{
    if (syncfusionLkSet == true){
        return true;
    }

    if (typeof license_key != 'string'){
        console.error("can't fetch license key", license_key);
        return false;
    }
    try{
        if (window["ej"]["base"]["validateLicense"](license_key) == false) {
            console.error("license key won't validate (ej.base.validateLicense)");
            return false;
        }
    }catch(err){
        console.error("can't validate license key, is ej2 loaded???", err);
        return false;
    }

    try{
        window["ej"]["base"]["registerLicense"](license_key);
    }catch(err){
        console.log("error calling register function: ", err)
        return false;
    }
    syncfusionLkSet = true; //flag um doppelte
    return true;
}

/**
 * Laded die uebersetzung nach dojo.locale rein als default fuer Syncfusion Componenten.
 * Setzt voraus, dass window.ej.base.L10n.load() verfuegbar ist.
 * @returns Boolean ob die Uebersetzung geladen werden konnte.
 */
function loadLanguage(){
    if (syncfusionLocSet == true){
        return true;
    }
    //wir ueberschreiben der einfachheit die default localisation
    //NOTE - translations sind von https://github.com/syncfusion/ej2-locale/blob/master/src/de.json
    let succ = false;
    let loadTranslation = false;
    let glob = {};

    let lang:string;

    try{
        lang = window.currentLanguageCode2;
    }catch{
        lang = "de"; //fallback
        console.info("syncfusionhelper: using fallback language german");
    }

    if (lang.includes("-") == true){
        lang = lang.split("-")[0];
    }
    lang = lang.toLowerCase();

    switch (lang) {
        case "de":
            loadTranslation = true;
            glob = getSyncfusionLangObj("de");
            break;
        case "it":
            loadTranslation = true;
            glob = getSyncfusionLangObj("it");
            break;
        case "en":
            loadTranslation = true;
            glob = getSyncfusionLangObj("en");
            break;
        case "es":
            loadTranslation = true;
            glob = getSyncfusionLangObj("es");
            break;
        case "fr":
            loadTranslation = true;
            glob = getSyncfusionLangObj("fr");
            break;
        case "pl":
            loadTranslation = true;
            glob = getSyncfusionLangObj("pl");
            break;
        default:
            succ = true; //wir laden keine translation und verwenden somit den default (en-US)
            break;
    }
    if (glob == null){
        loadTranslation = false;
    }

    if (loadTranslation){
        //NOTE - es gibt eins syncfusion bug (?, evtl. wegen dem zusammenladen von verschiedenen bundles?) wo beim zweiten mal
        //       laden von widget die localisation nicht beruecksichtigt wird, egal wie oder wie oft wir L10n.load() ausfuehren
        try{
            window["ej"]["base"]["L10n"]["load"]({
                "default_fallback": glob
            });
            window["ej"]["base"]["L10n"]["load"]({
                "en-US": glob
            });
            succ = true;
        }catch{
            succ = false;
        }
    }
    if (succ == true){
        syncfusionLocSet = true;
    }
    return succ;
}

//wir laden die translation aus den dependency lang scripts (Content/syncfusion/lang)
function getSyncfusionLangObj(langCode:string):Object|null{
    //cache damit wir schneller sind als der sf calendar denn wir nicht ausbremsen koennen ohne dass alles brennt und crashed in flammen :(
    let cacheStorage = PermissionHelper.getAvailableStorageMediumForCaching();
    let cacheKey = "sf_lang_" + langCode;
    let cacheObj = null;
    try{
        cacheObj = cacheStorage.getItem(cacheKey) ?? null;
    }catch{}
    if (cacheKey && cacheObj != null){
        if (typeof cacheObj == 'string'){
            cacheObj = JSON.parse(cacheObj);
        }
        return cacheObj;
    }

    let res:Object;
    if (typeof window["sf_lang"] != 'object'){
        window["sf_lang"] = {};
    }
    let langObj:Object = window["sf_lang"];
    let availableLanguages:string[] = Object.keys(langObj).map(l=>l.toLowerCase());
    let selectedLang = "en"; //default/fallback
    if (availableLanguages.includes(langCode.toLowerCase())){
        selectedLang = langCode.toLowerCase();
    }else{
        console.warn("syncfusion language not available", langCode);
        return null; //wird verwenden default aus lib, also return null
    }
    let originalKey = Object.keys(langObj).find(key => key.toLowerCase() === selectedLang);
    res = originalKey ? langObj[originalKey] : null;
    if (langObj != null && Object.keys(langObj).length > 0){
        try{
            cacheStorage.setItem(cacheKey, JSON.stringify(langObj));
        }catch{}
    }
    return res;
}

function getSfLangScriptPath(){
    let langCode = window.currentLanguageCode2 ?? "en";
    return window.appRoot + "Content/syncfusion/lang/" + langCode + ".js";
}

export { loadLicense, loadLanguage, getSfLangScriptPath, getSyncfusionLangObj}
